// Custom element for double exposure effect
// Dependencies: rft-double-exposure.css
// Version: 1.0.0

class RftVariantSelector extends HTMLElement {
  constructor() {
    super();
    this.parentSelector = ".ns-product";
    this.imageTargetSelector = ".product-card__media .product-card__image--primary";
    this.groupedFieldSelector = "gemstone color";
    this.productUrlSelectors = [".product-card__media", ".product-title"];
  }

  connectedCallback() {
    this.loadData();
    this.renderContainer();
    this.renderSwatches();
  }

  // get All information from non-visible elements ( noscript )
  loadData() {
    const noscript = this.querySelector("noscript");
    this.productData = JSON.parse(noscript.textContent) || {};
  }

  // Render container
  renderContainer() {
    this.innerHTML = `<div class="rft-swatches"></div><label class="rft-label">${this?.productData?.selected?.name || ''}</label>`;
  }

  // Render swatches
  renderSwatches() {
    let options = [];
    const container = this.querySelector(".rft-swatches");

    // Find in tags if group by exist in tags1. collection-swatch-group-by
    const tags = this.productData.tags1;
    const groupByTag = tags.find((tag) => tag.includes("collection-swatch-group-by"));
    if (groupByTag) {
      this.groupedFieldSelector = groupByTag.replace("collection-swatch-group-by:", "").trim().toLowerCase();
    }

    // count color options without duplicates
    this.colorCount = 0;
    this.productData.skus.forEach((variant) => {
      const swatch = document.createElement("button");
      swatch.classList.add("rft-swatch");
      const colorOption = variant.customFields.find((field) => field.key === this.groupedFieldSelector);
      if (!colorOption || options.includes(colorOption.value)) {
        return;
      }
      if (this.colorCount >= 4) {
        options.push(colorOption.value);
        this.colorCount++;
        return;
      }
      this.colorCount++;
      // Set default selected variant
      if (!this.productData?.selected) {
        this.productData.selected = {
          id: variant.id,
          name: colorOption.value,
          image: variant.imageUrl,
        };
        this.updateProductUrl();
        this.updateProductImage(variant.imageUrl);
      }
      options.push(colorOption.value);
      swatch.classList.add(`rft-swatch--${colorOption?.value?.toLowerCase()?.replace(/\s/g, "-")}`);
      Object.assign(swatch.dataset, {
        variant: variant.id,
        color: colorOption.value,
        image: variant.imageUrl || "",
        available: variant.availability == "InStock" ? "true" : "false",
      });
      this.attachSwatchEvents(swatch);
      container.appendChild(swatch);
      this.updateSwatches();
    });
    // if this.colorCount > 4, add +count label
    if (this.colorCount > 4) {
      const swatch = document.createElement("button");
      swatch.classList.add("rft-swatch");
      swatch.classList.add("rft-swatch--more");
      swatch.textContent = `+${this.colorCount - 4}`;
      container.appendChild(swatch);
    }

    // Current Label Name
  }

  attachSwatchEvents(swatch) {
    swatch.addEventListener("click", () => {
      if (swatch.dataset.available === "false") {
        return;
      }

      // Update selected variant
      this.productData.selected = {
        id: swatch.dataset.variant,
        name: swatch.dataset.color,
        image: swatch.dataset.image,
      };
      this.updateSwatches();
      this.updateProductImage(swatch.dataset.image);
      this.updateProductUrl();
    });
    // On hover, change image and reset on mouseout
    swatch.addEventListener("mouseover", () => {
      if (swatch.dataset.available === "false") {
        return;
      }
      this.updateProductImage(swatch.dataset.image);
    });
    swatch.addEventListener("mouseout", () => {
      if (swatch.dataset.available === "false") {
        return;
      }
      console.log(this.productData.selected.image);
      this.updateProductImage(this.productData.selected.image);
    });
  }

  updateProductUrl() {
    const url = this.productData.url;
    this.productUrlSelectors.forEach((selector) => {
      const productUrl = this.closest(this.parentSelector).querySelector(selector);
      productUrl.href = url + `?variant=${this.productData.selected.id}`;
    });
    this.querySelector(".rft-label").textContent = this.productData.selected
      ? this.productData.selected.name
      : '';
  }

  updateProductImage(imageUrl) {
    if (!imageUrl) {
      return;
    }
    const imageOptimized = this.optimizeImage(imageUrl);
    const target = this.closest(this.parentSelector).querySelector(this.imageTargetSelector);
    target.src = imageOptimized;
    target.removeAttribute("srcset");
  }

  updateSwatches() {
    const swatches = this.querySelectorAll(".rft-swatch");
    swatches.forEach((swatch) => {
      if (swatch.dataset.variant === this.productData.selected.id) {
        swatch.classList.add("rft-swatch--selected");
      } else {
        swatch.classList.remove("rft-swatch--selected");
      }
    });
  }

  optimizeImage(imageUrl) {
    // remove query parameters
    imageUrl = imageUrl.replace(/\?.+/, "");
    // get extension
    const extension = imageUrl.split(".").pop();
    imageUrl = imageUrl.replace(`.${extension}`, `_650x650.${extension}`);

    return imageUrl;
  }
}

customElements.define("rft-variant-selector", RftVariantSelector);
